import $ from 'jquery';

function isCPFCNPJValid(value) {
	let pCpfCnpj = value + '';
	let chCpfCnpj = '';
	let numCpfCnpj = '';
	let valid = true;

	for (let cpfcnpjCounter = 0; cpfcnpjCounter <= pCpfCnpj.length; cpfcnpjCounter++) {
		chCpfCnpj = pCpfCnpj.substr(pCpfCnpj.length - cpfcnpjCounter, 1);

		if ($.isNumeric(chCpfCnpj)) {
			numCpfCnpj = chCpfCnpj + numCpfCnpj;
		}
	}

	if (numCpfCnpj.length > 14) {
		valid = false;
	} else {
		if (numCpfCnpj.length > 11) {
			// CNPJ
			numCpfCnpj = Array(15).join('0') + numCpfCnpj;
			numCpfCnpj = numCpfCnpj.substring(numCpfCnpj.length, numCpfCnpj.length - 14);

			if (!numCpfCnpj.match(/^[0-9]{14}$/) || numCpfCnpj.match(/^(0{14}|1{14}|2{14}|3{14}|4{14}|5{14}|6{14}|7{14}|8{14}|9{14})$/)) {
				valid = false;
			} else {
				let cnpjW_A = [5,4,3,2,9,8,7,6,5,4,3,2];
				let cnpjW_B = [6,5,4,3,2,9,8,7,6,5,4,3,2];
				let cnpjSum;
				let cnpjCounter;
				let cnpjMod;
				let cnpjDV1 = 0;
				let cnpjDV2 = 0;

				cnpjSum = 0;

				for (cnpjCounter = 0; cnpjCounter < 12; cnpjCounter++) {
					cnpjSum = cnpjSum + (numCpfCnpj[cnpjCounter] * cnpjW_A[cnpjCounter]);
				}

				// calcula digito 1
				cnpjMod = cnpjSum % 11;

				if (cnpjMod >= 2) {
					cnpjDV1 = 11 - cnpjMod;
				}

				// calcula digito 2
				cnpjSum = 0;

				for (cnpjCounter = 0; cnpjCounter < 13; cnpjCounter++) {
					cnpjSum = cnpjSum + (numCpfCnpj[cnpjCounter] * cnpjW_B[cnpjCounter]);
				}

				cnpjMod = cnpjSum % 11;

				if (cnpjMod >= 2) {
					cnpjDV2 = 11 - cnpjMod;
				}

				if(cnpjDV1 !== parseInt(numCpfCnpj[12], 10) || cnpjDV2 !== parseInt(numCpfCnpj[13], 10)) {
					valid = false;
				}
			}
		} else {
			// CPF
			numCpfCnpj = Array(12).join('0') + numCpfCnpj;
			numCpfCnpj = numCpfCnpj.substring(numCpfCnpj.length, numCpfCnpj.length - 11);

			if (!numCpfCnpj.match(/^[0-9]{11}$/) || numCpfCnpj.match(/^(0{11}|1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11})$/)) {
				valid = false;
			} else {
				let cpfW_A = [10,9,8,7,6,5,4,3,2];
				let cpfW_B = [11,10,9,8,7,6,5,4,3,2];
				let cpfSum;
				let cpfCounter;
				let cpfMod;
				let cpfDV1 = 0;
				let cpfDV2 = 0;

				cpfSum = 0;

				for (cpfCounter = 0; cpfCounter < 9; cpfCounter++) {
					cpfSum = cpfSum + (numCpfCnpj[cpfCounter] * cpfW_A[cpfCounter]);
				}

				// calcula digito 1
				cpfMod = cpfSum % 11;

				if (cpfMod >= 2) {
					cpfDV1 = 11 - cpfMod;
				}

				// calcula digito 2
				cpfSum = 0;

				for (cpfCounter = 0; cpfCounter < 10; cpfCounter++) {
					cpfSum = cpfSum + (numCpfCnpj[cpfCounter] * cpfW_B[cpfCounter]);
				}

				cpfMod = cpfSum % 11;

				if (cpfMod >= 2) {
					cpfDV2 = 11 - cpfMod;
				}

				if (cpfDV1 !== parseInt(numCpfCnpj[9], 10) || cpfDV2 !== parseInt(numCpfCnpj[10], 10)) {
					valid = false;
				}
			}
		}
	}

	return valid;
}

export default {
	isNotBlank(value) {
		return value.toString() !== '';
	},

	isValidCPF(value) {
		return value.toString() !== '' && isCPFCNPJValid(value.toString());
	},

	isValidDate(value) {
		let re = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;

		return value.toString().length === 10 && value.match(re);
	},

	isValidEmail(value) {
		let re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

		return value.toString() !== '' && value.toString().match(re);
	},

	isValidCEP(value) {
		return value.toString().replace(/\D/g, '').length === 8;
	},

	isValidTelephone(value) {
		return value.replace(/\D/g, '').length === 10;
	},

	isValidCelphone(value) {
		return value.replace(/\D/g, '').length === 11;
	},

	hasMinLength(value, length) {
		return value.length >= length;
	}
};


// WEBPACK FOOTER //
// ./application/helpers/validationRules.js